import { a as t } from "../../../chunk-OA3DH5LS-40f95340.js";
const o = t("EditorOutput").parts(
  "bold",
  "boldItalic",
  "h1",
  "h2",
  "h3",
  "heading",
  "italic",
  "link",
  "list",
  "listItem",
  "paragraph",
  "root"
);
export {
  o as EditorOutputAnatomy
};
//# sourceMappingURL=EditorOutput.anatomy.es.js.map
